// GlobalContext.jsx
import React, { createContext, useEffect, useState } from 'react';
import { useWallet } from './WalletContextProvider';
import { getArtPackApprovedStatus, getArtPackById, getCampaignById, LoadCheckMenu } from '../utils/services';
import constants from '../utils/constants';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMemo } from 'react';
export const GlobalContext = createContext(null);

export const GlobalProvider = ({ children }) => {
  const navigate = useNavigate();
  const { account, apiConstants } = useWallet();
  const { pathname } = useLocation();
  const [campaign, setCampaign] = useState(null);
  const [artPack, setArtPack] = useState(null);
  const [spinner, setSpinner] = useState(false);
  const [userType, setUserType] = useState(null);
  const [menuState, setMenuState] = useState(null);
  const [campaignId, setCampaignId] = useState(sessionStorage.getItem(constants.CAMPAIGN_IDENTIFIER) || 0);
  const [artPackId, setArtPackId] = useState(sessionStorage.getItem(constants.ART_PACK_IDENTIFIER) || 0);
  const initialDistroPreset = useMemo(() => {
    return {
    beneficiary_distro: 100 - (2 * (1 + apiConstants.reddevcut)),
    sponsor_distro: (1 + apiConstants.reddevcut),
    artist_distro: (1 + apiConstants.reddevcut),
    seller_distro: 0
  };
  }, [apiConstants.reddevcut])

  const reset = () => {
    setArtPack(null);
    setCampaign(null);
    setSpinner(false);
    setMenuState(null);
    setCampaignId(0);
    setArtPackId(0);
    sessionStorage.removeItem(constants.CAMPAIGN_IDENTIFIER);
    sessionStorage.removeItem(constants.ART_PACK_IDENTIFIER);
    navigate("");
  }

  useEffect(() => {
    if (artPackId && artPackId !== "0" && artPackId !== 0) {
      const fetchArtPack = async () => {
        const data = await getArtPackById(account, artPackId);
        const approved = await getArtPackApprovedStatus(data)
        setArtPack({ ...data, approved });
      };
      fetchArtPack();
    }

  }, [account, artPackId])

  useEffect(() => {
    if (pathname.includes(constants.SPONSOR_BASE_PATH)) {
      setUserType("sponsor");
    } else if (pathname.includes(constants.ARTIST_BASE_PATH)) {
      setUserType("artist");
    } else if (pathname.includes(constants.PREVIEW_BASE_PATH)) {
      setUserType("preview");
    } else {
      setUserType(null);
    }
  }, [pathname])

  useEffect(() => {
    const fetchMenuState = async () => {
      if (userType && account) {
        const id = userType === "sponsor" ? campaign?.campaign_id : artPack?.art_pack_id;
        if (id) {
          const data = await LoadCheckMenu(userType, id, account);
          setMenuState(data);
          return;
        }
      }
      setMenuState(null);
    };

    fetchMenuState();
  }, [pathname, campaign, artPack]);




  useEffect(() => {
    if (campaignId && campaignId !== "0" && campaignId !== 0) {
      const fetchCampaign = async () => {
        const data = await getCampaignById(account, campaignId);
        setCampaign(data);
      };
      fetchCampaign();
    }
  }, [account, campaignId])

  useEffect(() => {
    if (!account) {
      navigate("");
    }
  }, [account]);

  useEffect(() => {
    if (!window.ethereum) return;

    const handleAccountsChanged = (accounts) => {
      reset(); // user disconnected wallet
    }

    const handleChainChanged = () => {
      reset(); // user disconnected wallet
    };

    window.ethereum.on('accountsChanged', handleAccountsChanged);
    window.ethereum.on('chainChanged', handleChainChanged);

    return () => {
      window.ethereum.removeListener('accountsChanged', handleAccountsChanged);
      window.ethereum.removeListener('chainChanged', handleChainChanged);
    };
  }, [reset]);

  const value = useMemo(() => {
    return {
      userType,
      campaign,
      artPack,
      spinner,
      menuState,
      initialDistroPreset,
      setCampaign,
      setArtPack,
      setSpinner,
      setMenuState
    };
  }, [userType, campaign, artPack, spinner, menuState]);

  return (
    <GlobalContext.Provider value={value}>
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobal = () => {
  const context = React.useContext(GlobalContext);
  if (context === undefined) {
    throw new Error('useGlobal must be used within a GlobalProvider');
  }
  return context;
} 